import { CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { from, ignoreElements, map, of, switchMap, take } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { AUTH_SESSION } from '@shared/di/auth-session.token';

export const authGuardFn: CanActivateChildFn = (route, state) => {
  const logger = inject(LoggerService);
  const session = inject(AUTH_SESSION);
  const router = inject(Router);
  const finalUrl = state.url;
  let options = {};
  try {
    options = {...options, ...route.data['guards']['role']};
  } catch {
    logger.debug('AuthGuard', 'No options found');
  } finally {
    logger.debug(`AuthGuard options: ${JSON.stringify(options)}`);
  }
  return session.loggedIn$.pipe(take(1), switchMap((token) => {
    if (token) return of(true);
    const loginUrl = '/auth/login';
    // ... otherwise, navigate to the login abstract-page
    logger.debug('AuthGuard', 'About to redirect to', loginUrl);
    // Do not redirect if we are already on loginUrl
    if (finalUrl === loginUrl) return of(false);
    return from(router.navigateByUrl(loginUrl, { state: { redirectTo: finalUrl } })).pipe(
      map(() => false), // return false to prevent the evaluation of the next guards (race condition?)
      ignoreElements(),
    );
  }));
};
